import React, { Component } from "react"
import { NamespacesConsumer as I18n } from "react-i18next"
import validator from "validator"
import { connect } from "react-redux"
import { compose } from "redux"
import { options1 } from "../ConstData/optionResearchArea"
import { initializeReactGA, eventGetReactGA } from "../../gafunction"

//component
import Thankyousignup from "./Thankyousignup"
import * as user_actions from "../../actions/action_user"
import RegisterForm from "../Registration/RegisterForm"
import {
	handleClickGM,
	handleClickFB,
	handleClickLN
} from "../Function/Register.function"
import { schema } from "../Function/WarningPassword.function"
import * as history_actions from "../../actions/action_history"

//material ui
import PropTypes from "prop-types"
import withStyles from "@material-ui/core/styles/withStyles"
import { MenuProps, RegisterStyle } from "../Style/RegisterStyle"

class Register extends Component {
	constructor(props) {
		super(props)
		this.state = {
			email: "",
			password: "",
			re_password: "",
			given_name: "",
			family_name: "",
			researchArea: "",
			value: false,
			isFocus: false,
			statuserror: false,
			erroremail: false,
			errorpassword: false,
			errorre_password: false,
			showPassword: false,
			openTermand: false,
			openThankyousignup: false
		}
		this.inputPassword = React.createRef()
	}
	componentDidMount() {
		window.fbq("track", "SignUpView")
		initializeReactGA()
		eventGetReactGA({
			category: "PageView",
			action: "Click Sign Up"
		})
	}
	UNSAFE_componentWillReceiveProps() {
		this.setState({
			email: "",
			password: "",
			re_password: "",
			given_name: "",
			family_name: "",
			researchArea: "",
			value: false,
			accepted_news: false,
			isFocus: false,
			statuserror: false,
			erroremail: false,
			errorpassword: false,
			errorre_password: false,
			showPassword: false,
			openTermand: false,
			openThankyousignup: false
		})
	}

	openThankyousignup = () => {
		this.setState({ openThankyousignup: true })
	}

	closeThankyousignup = () => {
		this.setState({ openThankyousignup: false })
	}

	handleChangecheck = (event, value) => {
		if (value === "subscribe") {
			this.setState({ accepted_news: event.target.checked })
		} else {
			this.setState({ value: event.target.checked })
		}
	}

	openprivacy = () => {
		this.setState({ openTermand: true })
	}

	closeprivacy = () => {
		this.setState({ openTermand: false })
	}

	handleClickShowPassword = () => {
		this.setState({ showPassword: !this.state.showPassword })
	}

	handleFocus = () => {
		this.setState({ isFocus: true })
	}
	handleChangeresearchArea = (e, { value }) => {
		this.setState({ researchArea: value })
	}
	handleChange = (event) => {
		if (event.target.id === "email") {
			this.setState({
				[event.target.id]: event.target.value
					.toLowerCase()
					.trim()
					.replace(/\s+/g, "")
			})
		} else if (
			event.target.id === "password" ||
			event.target.id === "re_password"
		) {
			this.setState({
				[event.target.id]: event.target.value.replace(/\s+/g, "")
			})
		} else {
			this.setState({
				[event.target.id]: event.target.value
			})
		}
		if (event.target.id === "email") {
			if (event.target.value.length === 0) {
				this.setState({ erroremail: false })
			} else {
				if (
					validator.isEmail(
						event.target.value.toLowerCase().trim().replace(/\s+/g, "")
					)
				) {
					this.setState({ erroremail: false })
				} else {
					this.setState({ erroremail: true })
				}
			}
		}
		if (event.target.id === "password") {
			if (event.target.value.length === 0) {
				this.setState({ errorpassword: false })
			} else {
				if (schema.validate(event.target.value.replace(/\s+/g, ""))) {
					this.setState({ errorpassword: false })
				} else {
					this.setState({ errorpassword: true })
				}
			}
		}
		if (event.target.id === "re_password") {
			if (event.target.value.length === 0) {
				this.setState({ errorre_password: false })
			} else {
				if (schema.validate(event.target.value.replace(/\s+/g, ""))) {
					this.setState({ errorre_password: false })
				} else {
					this.setState({ errorre_password: true })
				}
			}
		}
	}

	validateForm = () => {
		if (
			!validator.isEmail(this.state.email) ||
			!schema.validate(this.state.password) ||
			!schema.validate(this.state.re_password) ||
			this.state.email.length === 0 ||
			this.state.password.length < 8 ||
			this.state.re_password.length < 8 ||
			this.state.given_name.length <= 0 ||
			this.state.family_name.length <= 0 ||
			this.state.researchArea.length <= 0 ||
			this.state.value !== true ||
			this.state.password !== this.state.re_password
		) {
			return false
		}
		return true
	}
	handleConfirmationSubmit = (event, t) => {
		event.preventDefault()
		let {
			email,
			password,
			given_name,
			family_name,
			researchArea,
			accepted_news
		} = this.state
		this.props
			.signup_user(
				{
					email,
					password,
					given_name,
					family_name,
					researchArea,
					accepted_news
				},
				t
			)
			.then(async (res) => {
				this.props.handleClickClose()
				this.props.history.push("/signup_success")
				this.setState({ showPassword: false })
				if (accepted_news) {
					await this.props.subscribe_new(email)
				}
			})
			.catch((err) => this.props.handleClickClose())
	}
	render() {
		const {
			classes,
			handleClickClose,
			Open,
			finish,
			finishgm,
			finishfb,
			finishln,
			login_gm,
			login_fb,
			login_ln,
			create_user,
			get_user,
			update_latest_login
		} = this.props
		const {
			erroremail,
			errorpassword,
			errorre_password,
			email,
			password,
			re_password,
			given_name,
			family_name,
			researchArea,
			value,
			accepted_news,
			showPassword,
			openTermand,
			openThankyousignup,
			isFocus
		} = this.state
		return (
			<I18n>
				{(t) => {
					return (
						<div className="Register">
							<RegisterForm
								researchArea={researchArea}
								handleChangeresearchArea={this.handleChangeresearchArea}
								MenuProps={MenuProps}
								options={options1}
								isFocus={isFocus}
								classes={classes}
								t={t}
								Open={Open}
								erroremail={erroremail}
								errorpassword={errorpassword}
								errorre_password={errorre_password}
								email={email}
								password={password}
								re_password={re_password}
								given_name={given_name}
								family_name={family_name}
								value={value}
								accepted_news={accepted_news}
								finish={finish}
								showPassword={showPassword}
								openTermand={openTermand}
								handleClickClose={handleClickClose}
								handleChange={this.handleChange}
								warningpassword={this.warningpassword}
								handleFocus={this.handleFocus}
								inputPassword={this.inputPassword}
								handleClickShowPassword={this.handleClickShowPassword}
								handleChangecheck={this.handleChangecheck}
								validateForm={this.validateForm}
								handleConfirmationSubmit={this.handleConfirmationSubmit}
								finishgm={finishgm}
								finishfb={finishfb}
								finishln={finishln}
								login_gm={login_gm}
								login_fb={login_fb}
								login_ln={login_ln}
								handleClickGM={handleClickGM}
								handleClickFB={handleClickFB}
								handleClickLN={handleClickLN}
								openprivacy={this.openprivacy}
								closeprivacy={this.closeprivacy}
								create_user={create_user}
								get_user={get_user}
								update_latest_login={update_latest_login}
								history={this.props.history}
							/>
							<Thankyousignup
								t={t}
								Open={openThankyousignup}
								handleClickClose={this.closeThankyousignup}
							/>
						</div>
					)
				}}
			</I18n>
		)
	}
}

Register.propTypes = {
	classes: PropTypes.object.isRequired
}
function mapStateToProps(reduxState) {
	return {
		finishgm: reduxState.UserReducer.finishgm,
		finishfb: reduxState.UserReducer.finishfb,
		finishln: reduxState.UserReducer.finishln,
		finish: reduxState.UserReducer.finish
	}
}
const mapDispatchToProps = function (dispatch) {
	return {
		login_fb: (data) => dispatch(user_actions.login_fb(data)),
		login_gm: (data) => dispatch(user_actions.login_gm(data)),
		login_ln: (data) => dispatch(user_actions.login_ln(data)),
		signup_user: (data, t) => dispatch(user_actions.signup_user(data, t)),
		create_user: (data) => dispatch(user_actions.create_user(data)),
		get_user: (user_id, user) => dispatch(user_actions.get_user(user_id, user)),
		subscribe_new: (email) => dispatch(history_actions.subscribe_new(email)),
		update_latest_login: (data) =>
			dispatch(user_actions.update_latest_login(data))
	}
}
export default compose(
	withStyles(RegisterStyle),
	connect(mapStateToProps, mapDispatchToProps)
)(Register)
